import { stringify } from 'qs';

import { BaseObjectStrapi, StrapiQueryParams } from 'types/strapiApi';
const STRAPI_URL = import.meta.env.VITE_STRAPI_URL;

export const BASE_STRAPI_URL = `${STRAPI_URL}/api`;

export const createStrapiApiUrl = (path: string, params?: BaseObjectStrapi): string => {
  const search = stringify(params, {
    addQueryPrefix: true,
    encode: false,
    skipNulls: true,
  });

  return `${BASE_STRAPI_URL}${path + search}`;
};

export const strapiApiUrls = {
  project: (params: StrapiQueryParams) => createStrapiApiUrl('/projects', params),
  projectYears: () => createStrapiApiUrl('/projects/years'),
  projectSlug: (slug: string, params: StrapiQueryParams) => createStrapiApiUrl(`/projects/${slug}`, params),
  generalInformation: (params: StrapiQueryParams) => createStrapiApiUrl('/general-information', params),
  about: (params: StrapiQueryParams) => createStrapiApiUrl('/about-page', params),
  teamResponsible: (params: StrapiQueryParams) => createStrapiApiUrl('/team-members/responsible', params),
  materials: (params: StrapiQueryParams) => createStrapiApiUrl('/materials', params),
  materialTypes: (params?: StrapiQueryParams) => createStrapiApiUrl('/material-types', params ?? {}),
};
